import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: 4,
    marginTop: theme.spacing(4),
  },
  buttonIcon: {
    marginRight: `${theme.spacing(2)} !important`,
  },
  text: {
    lineHeight: '1.5em',
    marginTop: theme.spacing(2),
    color: 'rgba(0, 0, 0, 0.6)',
  },
}))
